<template>
  <v-container class="pa-0 ma-0 academics-page">
    <h1 class="show-title mb-10">{{ content.title }}</h1>
    <div class="academics-text">
      <p>
        If you believe you have an idea worth protecting or that may be
        commercially valuable, talk to us! We can help you to turn a promising
        idea or technology into an attractive opportunity to industry or
        investors.
      </p>

      <p>
        Whether it is a very early stage idea, research results attracting
        commercial interest or if you just want to know more about research
        commercialization at NOVA, send us a message.
      </p>

      <ContactForm />

      <p>
        Following this first contact we can talk confidentiality about your idea
        and define the next steps to take it further on. In case of a potential
        invention, you should fill out this
        <a href="#">disclosure form.</a>
      </p>
      <p>
        For us it is important to know what particular technical, commercial or
        social problem your idea is trying to solve, as well as the social
        and/or economic impact it may have.
      </p>
      <p>
        More information about the technology transfer process can be found
        <a href="#">here</a>. We also advise you to look at our
        <a href="#">FAQ page</a> prior to a first conversation.
      </p>
    </div>
  </v-container>
</template>

<script>
import ContactForm from '@/components/ContactForm'

export default {
  name: 'TellUsYourIdea',
  components: {
    ContactForm,
  },
  props: {
    content: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style></style>
